import { create } from 'zustand';
import { GetChurchInfo, UpdateChurchInfo, ChurchInfo, UpdateChurchInfoI, ServiceTime } from '../api/api';
import toast from 'react-hot-toast';

export type { ServiceTime };

interface GetChurchInfoResponse {
  data: {
    churchInfo: ChurchInfo;
  };
}

interface ChurchInfoResponse {
  data: {
    churchInfo: ChurchInfo;
  };
  status: boolean;
  message: string;
}

interface ChurchInfoStore {
  churchInfo: ChurchInfo | null;
  loading: boolean;
  error: string | null;
  getChurchInfo: (isPublic?: boolean) => Promise<void>;
  updateChurchInfo: (churchInfo: UpdateChurchInfoI) => Promise<void>;
}

export const useChurchInfoStore = create<ChurchInfoStore>((set, get) => ({
  churchInfo: null,
  loading: false,
  error: null,

  getChurchInfo: async (isPublic?: boolean) => {
    set({ loading: true, error: null });
    const { data, error } = await GetChurchInfo<GetChurchInfoResponse>(isPublic);

    if (error) {
      set({ loading: false, error: error as string });
      return;
    }

    set({
      churchInfo: data.data.churchInfo || null,
      loading: false,
    });
  },

  updateChurchInfo: async (churchInfo: UpdateChurchInfoI) => {
    set({ loading: true, error: null });
    const { data, error } = await UpdateChurchInfo<ChurchInfoResponse>(churchInfo);

    if (error || !data.status) {
      set({ loading: false, error: (error as string) || 'Failed to update church info' });
      return;
    }

    set({ churchInfo: data.data.churchInfo, loading: false });
    toast.success('Church information updated successfully');
  },
}));
